// root-wrapper.jsx
import React from 'react';

import Layout from './src/components/layout';

// eslint-disable-next-line import/prefer-default-export
export const rootWrapper = ({ element, props }) => <Layout {...props}>{element}</Layout>;
